import { createSlice } from "@reduxjs/toolkit"

interface GroupProfileState {
  groupData: Array<any>
  selectedGroupSk: any
  groupProfileDetails: Array<any>
  metricDetailsBuckets: Array<any>
  selectedBucket: any
  selectedBucketDetails: Array<any>
  groupInfo: any
  selectedIndex: any
  groupDetailsRegions: Array<any>
  groupDetailsPracticeresult: Array<any>
  selectAllDisableCheck: any
  practiceList: Array<any>
}

const initialState: GroupProfileState = {
  groupData: [],
  selectedGroupSk: null,
  groupProfileDetails: [],
  metricDetailsBuckets: [],
  selectedBucket: null,
  selectedBucketDetails: [],
  groupInfo: {},
  selectedIndex: null || "",
  groupDetailsRegions: [],
  groupDetailsPracticeresult: [],
  selectAllDisableCheck: false,
  practiceList: [],
}

const groupProfileSlice: any = createSlice({
  name: "groupProfile",
  initialState,
  reducers: {
    setGroupData: (state, action) => {
      state.groupData = action.payload
    },
    setSelectedGroupSk: (state, action) => {
      state.selectedGroupSk = action.payload
    },
    setGroupProfileDetails: (state, action) => {
      state.groupProfileDetails = action.payload
    },
    setSelectedIndex: (state, action) => {
      state.selectedIndex = action.payload
    },
    setMetricDetailsBuckets: (state, action) => {
      state.metricDetailsBuckets = action.payload
    },
    setSelectedBucket: (state, action) => {
      state.selectedBucket = action.payload
    },
    setSelectedBucketDetails: (state, action) => {
      state.selectedBucketDetails = action.payload
    },
    setIsAssignedBucketDetails: (state: any, action) => {
      const { index, checkValue } = action.payload
      state.selectedBucketDetails.metrics[index].isAssigned = checkValue
    },
    setGroupProfileDetailsIsAssignedChanged: (state, action) => {
      const { index, checkValue } = action.payload
      state.groupProfileDetails[state.selectedIndex].metrics[index].isAssigned =
        checkValue
    },
    setGroupProfileDetailChanged: (state, action) => {
      const { index, checkValue } = action.payload
      state.groupProfileDetails[index] = checkValue
    },
    setGroupInfo: (state, action) => {
      state.groupInfo = action.payload
    },
    setGroupDetailsRegions: (state, action) => {
      state.groupDetailsRegions = action.payload
    },
    setGroupDetailsPracticeresult: (state, action) => {
      state.groupDetailsPracticeresult = action.payload
    },
    setSelectAllDisableCheck: (state, action) => {
      state.selectAllDisableCheck = action.payload
    },
    setPracticeList: (state, action) => {
      state.practiceList = action.payload
    },
    updatePracticeList: (state, action) => {
      const practiceSk = action.payload
      state.practiceList = state.practiceList.map((practice) => {
        if (practice.practice_sk === practiceSk) {
          return {
            ...practice,
            practice_status:
              practice.practice_status == "active" ? "inactive" : "active",
          }
        }
        return practice
      })
    },
  },
})

export default groupProfileSlice.reducer

export const {
  setGroupData,
  setSelectedGroupSk,
  setGroupProfileDetails,
  setMetricDetailsBuckets,
  setSelectedBucket,
  setSelectedBucketDetails,
  setGroupProfileDetailsIsAssignedChanged,
  setGroupProfileDetailChanged,
  setGroupInfo,
  setIsAssignedBucketDetails,
  setSelectedIndex,
  setGroupDetailsRegions,
  setGroupDetailsPracticeresult,
  setSelectAllDisableCheck,
  setPracticeList,
  updatePracticeList,
} = groupProfileSlice.actions
